// extracted by mini-css-extract-plugin
export default {"container":"patronage_container__0p3al","header":"patronage_header__qu9-G","logos":"patronage_logos__vEzJ8","logo":"patronage_logo__Yv9x1"};